import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    setArrivalDate,
    setDepartureDate,
    setKeywords,
    hideDatesPopup,
    goToSerp
} from '../../../actions/search';
import {removeDatesFromSearchCookie} from '../../../utils/cookies';
import {pushEdapEvent} from '../../../utils/edap';
import {UNREFINED_KEY} from '../../../utils/listings';
import PropTypes from 'prop-types';
import Modal from '@homeaway/react-modal';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import {DayAvailability, CheckInCheckOut, DatePickerIcon} from '@homeaway/react-search-components';
import {DateRangePicker, dateUtils} from '@homeaway/react-date-pickers';
import determineIfMobile from '@homeaway/react-determine-if-mobile';

import './DateModal.less';

function mapStateToProps(state) {
    return {
        actionLocation: state.search.actionLocation,
        arrivalDate: state.search.arrivalDate,
        dateModalSerpKeywords: state.search.dateModalSerpKeywords,
        departureDate: state.search.departureDate,
        eventrefinements: state.search.eventrefinements,
        goToSerpAction: state.search.goToSerpAction || goToSerp,
        isMobile: state.config.isMobile,
        locale: state.i18n.locale,
        messages: state.modules.searchBoxLite.labels,
        datedSearchModal: state.modules.datedSearchModal,
        propertyName: state.search.propertyName,
        segmentKey: state.destination.segmentFilters.key || UNREFINED_KEY,
        serpUrlFilters: state.destination.serpUrlFilters,
        showDatesModal: state.search.showDatesModal,
        title: state.search.title,
        tripleId: state.search.tripleId,
        thumbnailUrl: state.search.thumbnailUrl
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export class DateModalComponent extends Component {
    static propTypes = {
        actionLocation: PropTypes.string,
        arrivalDate: PropTypes.string,
        dateModalSerpKeywords: PropTypes.string,
        departureDate: PropTypes.string,
        eventrefinements: PropTypes.string,
        goToSerpAction: PropTypes.func,
        isLoadingSerp: PropTypes.bool,
        isMobile: PropTypes.bool,
        locale: PropTypes.string,
        messages: PropTypes.object,
        propertyName: PropTypes.string,
        segmentKey: PropTypes.string,
        serpUrlFilters: PropTypes.object,
        showContinueButton: PropTypes.bool,
        showDatesModal: PropTypes.bool,
        tripleId: PropTypes.string,
        title: PropTypes.string,
        thumbnailUrl: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {
            checkOut: null,
            checkIn: null
        };
    }

    goToSerpOrPdp = () => {
        const {
            arrivalDate,
            dateModalSerpKeywords,
            departureDate,
            goToSerpAction,
            dispatch,
            segmentKey,
            serpUrlFilters
        } = this.props;
        const checkIn = this.state.checkIn || arrivalDate;
        const checkOut = this.state.checkOut || departureDate;
        const hasDates = !!(checkIn && checkOut);

        if (hasDates) {
            dispatch(setArrivalDate(checkIn));
            dispatch(setDepartureDate(checkOut));
        } else {
            removeDatesFromSearchCookie();
        }

        if (dateModalSerpKeywords) {
            dispatch(setKeywords(dateModalSerpKeywords));
        }

        this.sendToEdap();
        this.setState({isLoadingSerp: true});

        dispatch(goToSerpAction({
            datedSearchSubmit: hasDates,
            refinementKey: segmentKey,
            reportEdapEvent: false,
            segmentKey,
            serpUrlFilters
        }));
    };

    handleDateRangeChange = (checkIn, checkOut) => {
        this.setState({
            checkIn,
            checkOut,
            showContinueButton: !!((checkIn && checkOut) || (!checkIn && !checkOut))
        });

        const {dispatch} = this.props;

        dispatch(setArrivalDate(checkIn));
        dispatch(setDepartureDate(checkOut));
    };

    handleDateRangeFocus = () => {
        this.setState({datePickerFocused: true});
    };

    modalCloseHandler = () => {
        this.setState({
            checkIn: null,
            checkOut: null,
            propertyName: null,
            title: null,
            tripleId: null
        });

        const {
            actionLocation,
            dispatch
        } = this.props;

        dispatch(hideDatesPopup());

        pushEdapEvent('generic.event', {
            actionlocation: `${actionLocation}-dated-search-modal`,
            eventcategory: 'dated-search-modal',
            eventaction: 'modal-dismissed'
        }, {delayProcessing: true});
    };

    onDateModalClear = () => {
        this.setState({
            checkIn: null,
            checkOut: null,
            showContinueButton: false
        });

        removeDatesFromSearchCookie();
    };

    onDateModalClose = () => {
        const state = {
            datePickerFocused: false,
            tripleId: null
        };

        if (!this.state.checkIn || !this.state.checkOut) {
            Object.assign(state, {
                checkIn: null,
                checkOut: null,
                showContinueButton: false
            });
        }

        this.setState(state);
    };

    getPrettyCheckInOut(checkIn, checkOut, inModal = false) {
        const {
            showDatesModal,
            messages: {
                datePicker: label
            }
        } = this.props;

        if (this.state.datePickerFocused !== true && (!checkIn && !checkOut)) {
            return (<span/>);
        }

        return (
            <CheckInCheckOut
                isOpen={showDatesModal}
                inModal={inModal}
                checkIn={checkIn}
                checkInLabel={label.checkIn}
                checkOut={checkOut}
                checkOutLabel={label.checkOut}
                ref={'check-in-out'}
            />
        );
    }

    sendToEdap() {
        const {
            actionLocation,
            arrivalDate,
            departureDate,
            eventrefinements
        } = this.props;
        const checkIn = this.state.checkIn || arrivalDate;
        const checkOut = this.state.checkOut || departureDate;

        const eventType = ['search', 'submit'];
        const eventData = {
            actionlocation: `${actionLocation}-dated-search-modal`,
            eventrefinements
        };

        if (checkIn && checkOut) {
            eventData.startdate = checkIn;
            eventData.enddate = checkOut;

            eventType.unshift('dated');
        }

        pushEdapEvent(eventType.join('.'), eventData, {delayProcessing: true});
    }

    render() {
        const {
            arrivalDate,
            departureDate,
            isMobile,
            locale,
            showDatesModal,
            messages,
            thumbnailUrl,
            propertyName,
            datedSearchModal
        } = this.props;
        const checkIn = this.state.checkIn || arrivalDate;
        const checkOut = this.state.checkOut || departureDate;
        const isLoadingSerp = this.state.isLoadingSerp || false;
        const showContinueButton = this.state.showContinueButton || !!(checkIn && checkOut);

        const dateFormatOptions = {month: 'short', day: 'numeric', weekday: 'short'};

        const checkInDate = dateUtils.getLocaleDateString(checkIn, locale, dateFormatOptions);
        const checkOutDate = dateUtils.getLocaleDateString(checkOut, locale, dateFormatOptions);

        const label = messages.datePicker;

        const dateSelectionCls = checkIn // eslint-disable-line no-nested-ternary
            ? checkOut
                ? 'dates-selected-both'
                : 'dates-selected-checkin-only'
            : 'dates-selected-none';

        const img = thumbnailUrl ? (<div className="image">
            <img src={thumbnailUrl} alt={propertyName} />
        </div>) : null;

        return (
            <Modal
                id={'dates-popup'}
                ref={'modal'}
                title={datedSearchModal.title}
                closeOnOutsideClick
                header
                isOpen={showDatesModal}
                modalAnimation={isMobile ? 'none' : 'modal-from-center'}
                onClose={this.modalCloseHandler}
                className={'modal--serp'}
            >
                {isMobile && img}
                <p className={'modal__subheading'}>
                    {datedSearchModal.subheading}
                </p>
                <div className={thumbnailUrl ? 'container-image' : 'container'}>
                    {!isMobile && img}
                    <div className={`popup-container ${dateSelectionCls}`}>
                        <DateRangePicker
                            className={'DateModal__range'}
                            clearButtonLabel={label.labels}
                            consolidateInputs
                            continueButtonLabel={label.done}
                            dateFormatOptions={dateFormatOptions}
                            disableTextInput
                            enableSameDayDateRange={false}
                            endDate={checkOut}
                            fadeOutDuration={0}
                            inputLabel1={label.dates}
                            inputLabel2={label.checkOut}
                            inputIcon1={<DatePickerIcon />}
                            inputName1={'date-modal-checkin'}
                            inputName2={'date-modal-checkout'}
                            isMobile={isMobile}
                            modalTitle={this.getPrettyCheckInOut(checkInDate, checkOutDate, true)}
                            ref={'date-range'}
                            showContinueButton={showContinueButton}
                            startDate={checkIn}
                            onClose={this.onDateModalClose}
                            onOpen={this.handleDateRangeFocus}
                            dayTemplateComponent={DayAvailability}
                            onDateRangeChange={this.handleDateRangeChange}
                            onDateRangeClear={this.onDateModalClear}
                            id={'date-modal'}
                        />
                        {this.getPrettyCheckInOut(checkInDate, checkOutDate)}
                        <button
                            type={'submit'}
                            className={'btn btn-primary go-button'}
                            onClick={this.goToSerpOrPdp}
                        >
                            {datedSearchModal.button}
                            <LoadingOverlay loading={isLoadingSerp} />
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export const DateModal = connect(mapStateToProps, mapDispatchToProps)(determineIfMobile(DateModalComponent));

export default DateModal;
